import { filterOptions } from '@/utils/query-base'

const city = filterOptions(['EQ', 'EMPTY', 'NEMPTY', 'NE'])
const all = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'BT', 'GT', 'LT', 'LE', 'GE'])
const cusname = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'CP-S'])

export const pageSearch = {
  'matnr': {
    title: '产品编码',
    type: 'dialog',
    equation: all,
    dialog: {
      component: 'ProductSelect',
      title: '产品编码'
    }
  },
  'maktx': {
    title: '产品名称',
    type: 'input',
    equation: all
  },
  'matfrom': {
    title: '累计材料下达期间',
    type: 'date',
    equation: all
  },
  'prodfrom': {
    title: '累积生产下达期间',
    type: 'date',
    equation: all
  },
  'zzfld00001h': {
    title: '营销单元',
    type: 'select',
    equation: city,
    dictionary: 'sale'
  }
}

export default {
  'name1': {
    title: '营销单元'
  },
  'product_id': {
    title: '产品',
    // type: 'dialog',
    equation: all,
    dialog: {
      component: 'ProductSelect',
      title: '产品'
    },
    width: 200
  },
  'short_text': {
    title: '产品描述',
    width: 400
  },
  'wlybrand': {
    title: '品牌'
  },
  'pocycle': {
    title: '包材采购周期(天)',
    width: 140,
    xlsxFmt: {
      t: 'n'
    }
  },
  'powarning': {
    title: '包材安全预警量(件)',
    width: 150,
    xlsxFmt: {
      t: 'n'
    }
  },
  'unit': {
    title: '单位'
  },
  'matl_planqty_box': {
    title: '累计材料下达',
    xlsxFmt: {
      t: 'n'
    }
  },
  'prod_planqty_box': {
    title: '累积生产下达',
    xlsxFmt: {
      t: 'n'
    }
  },
  'prod_planqty_box_a': {
    title: '累积生产下达A',
    xlsxFmt: {
      t: 'n'
    }
  },
  'prod_planqty_box_b': {
    title: '累积生产下达B',
    xlsxFmt: {
      t: 'n'
    }
  },
  'prod_planqty_box_c': {
    title: '累积生产下达C',
    xlsxFmt: {
      t: 'n'
    }
  },
  'material_confirmed': {
    title: '当前材料余量(含采购中)',
    width: 200,
    xlsxFmt: {
      t: 'n'
    }
  },
  'available_material': {
    title: '当前材料余量(不含采购中)',
    width: 200,
    xlsxFmt: {
      t: 'n'
    }
  },
  'material_purchasing': {
    title: '当前材料余量(采购中)',
    width: 200,
    xlsxFmt: {
      t: 'n'
    }
  },
  'initial_material': {
    title: '期初材料量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'adjust_material': {
    title: '调整材料量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'prod_planqty_box_plan': {
    title: '下达中生产总量',
    width: 130,
    xlsxFmt: {
      t: 'n'
    }
  },
  'prod_planqty_box_a_plan': {
    title: '下达中A生产总量',
    width: 130,
    xlsxFmt: {
      t: 'n'
    }
  },
  'prod_planqty_box_b_plan': {
    title: '下达中B生产总量',
    width: 130,
    xlsxFmt: {
      t: 'n'
    }
  },
  'prod_planqty_box_c_plan': {
    title: '下达中C生产总量',
    width: 130,
    xlsxFmt: {
      t: 'n'
    }
  },
  'prod_all': {
    title: '下达中+正式下达',
    width: 130,
    xlsxFmt: {
      t: 'n'
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/material-plan-manage/config/materialReport.js